export default __webpack_public_path__ + "static/16-b7b99a64e81ce99aa88f15470e9f89e6.jpg";